export default __webpack_public_path__ + "static/media/SS6-min.9e8856db.png";